import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  eventLifecycleFilters,
  lifecycleCounts,
  lifecycleStatusParam,
  resolveEventLifecycleFilter,
  type EventLifecycleFilter,
} from "./eventLifecycle";
import type { OperationsSnapshot } from "../../domain/operations";

export function EventLifecycleTabs({ snapshot }: { snapshot: OperationsSnapshot }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeFilter = resolveEventLifecycleFilter(searchParams.get("status"));
  const counts = lifecycleCounts(snapshot);
  const stripRef = useRef<HTMLDivElement>(null);
  const activeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeRef.current?.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
  }, [activeFilter]);

  function selectFilter(filter: EventLifecycleFilter) {
    const next = new URLSearchParams(searchParams);
    next.set("status", lifecycleStatusParam(filter));
    setSearchParams(next, { replace: true });
  }

  return (
    <div className="event-lifecycle-tabs" ref={stripRef} role="tablist" aria-label="Event lifecycle">
      {eventLifecycleFilters.map((item) => {
        const active = activeFilter === item.id;
        return (
          <button
            key={item.id}
            ref={active ? activeRef : undefined}
            type="button"
            role="tab"
            aria-selected={active}
            className={`event-lifecycle-tab ${active ? "active" : ""}`}
            onClick={() => selectFilter(item.id)}
          >
            <span>{item.label}</span>
            <span className="event-lifecycle-count">{counts[item.id]}</span>
          </button>
        );
      })}
    </div>
  );
}
